"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomHtml = void 0;
var _react = _interopRequireDefault(require("react"));
var _bricksTheme = _interopRequireDefault(require("@titelmedia/bricks-theme"));
var _styles = require("./styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const CustomHtml = ({
  html
}) => {
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_bricksTheme.default, null), _react.default.createElement(_styles.CustomStyles, null), _react.default.createElement(_styles.Container, {
    dangerouslySetInnerHTML: {
      __html: html
    }
  }));
};
exports.CustomHtml = CustomHtml;
//# sourceMappingURL=index.js.map